import {useMemo, useState} from 'react'
import {PageHeader} from '../components/ui/page-header'
import {WarningPill} from '../components/ui/warning-pill'
import {ArrowCanvas, ArrowControls, ArrowParamsTable, type ArrowFillKey} from '../components/arrow'
import {computeArrow, formatWarning, type ArrowDirection, type ArrowVariant} from '../lib/lvs-arrow'

export function BultasPage() {
    const [direction, setDirection] = useState<ArrowDirection>('right')
    const [h, setH] = useState<number>(350)
    const [variant, setVariant] = useState<ArrowVariant>('compound')
    const [stemA, setStemA] = useState<number>(2)
    const [fill, setFill] = useState<ArrowFillKey>('white')

    const geometry = useMemo(
        () => computeArrow({direction, h, variant, stemA}),
        [direction, h, variant, stemA]
    )

    return (
        <div className='space-y-8'>
            <PageHeader
                eyebrow='LVS 77-3:2016 / 9.1. att. / C pielikums 165. lpp.'
                title='Bultas'
                subtitle='LVS 77-3:2016 9.1. attēla bultas. 1. fāze: horizontālās 705. zīmes bultas (pa kreisi un pa labi). Stieņa platums 1A, galva 3A platumā un garumā, barbas 0.25A aiz iezīmes. Salikta variants A = 0.5h, vienkārša A = 0.2h.'
            />

            <ArrowControls
                direction={direction}
                onDirectionChange={setDirection}
                h={h}
                onHChange={setH}
                variant={variant}
                onVariantChange={setVariant}
                stemA={stemA}
                onStemAChange={setStemA}
                fill={fill}
                onFillChange={setFill}
            />

            {geometry.warnings.length > 0 && (
                <div className='flex flex-wrap gap-2'>
                    {geometry.warnings.map((w, i) => (
                        <WarningPill key={i}>{formatWarning(w)}</WarningPill>
                    ))}
                </div>
            )}

            <ArrowCanvas
                geometry={geometry}
                fill={fill}
            />

            <ArrowParamsTable geometry={geometry} />
        </div>
    )
}
